/**
 * Skip to Results Components
 *
 * Minimal waiting experience components for paid users.
 * Premium feature: Skip theatrical animations, go straight to results.
 *
 * USAGE:
 * ```tsx
 * import { SkipToResultsLoader } from '@/components/skip-to-results';
 * import { useSkipToResults } from '@/hooks/useSkipToResults';
 *
 * // In analyze page when mode is 'quick':
 * const { shouldShowLoader } = useSkipToResults({
 *   analysisId: params.id,
 *   isQuickMode: variant === 'quick',
 *   onNavigate: (id) => router.replace(`/results/${id}`),
 * });
 *
 * if (shouldShowLoader) {
 *   return <SkipToResultsLoader message={userMessage} />;
 * }
 * ```
 */

export { SkipToResultsLoader, default } from './SkipToResultsLoader';
